const initialState = {
  resultsBlackoutesList: { records: [] },
  resultsBlackout: {},
  resultsBlackoutAdd: {},
  resultsBlackoutPatch: {},
  resultsBlackoutDelete: {},
  resultsBlackoutProductAdd: {},
  resultsBlackoutProducts: [],
  resultsBlackoutProductsDelete: {},
  resultsProductBlackoutList: [],
  loading: false,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    // START LOADING
    case "GET_LIST_BLACKOUT":
    case "GET_LIST_PRODUCT_BLACKOUT":
    case "GET_BLACKOUT":
    case "ADD_BLACKOUT":
    case "UPDATE_BLACKOUT":
    case "DELETE_BLACKOUT":
    case "ADD_BLACKOUT_PRODUCT":
    case "DELETE_BLACKOUT_PRODUCTS":
    case "GET_BLACKOUT_PRODUCTS":
      newState.loading = true;
      break;

    // STOP LOADING & HANDLE DATA
    case "LIST_BLACKOUT_RESPONSE_GET":
      newState.resultsBlackoutesList = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_RESPONSE_GET":
      newState.resultsBlackout = action.value;
      newState.loading = false;
      break;
    case "LIST_PRODUCT_BLACKOUT_RESPONSE_GET":
      newState.resultsProductBlackoutList = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_RESPONSE_ADD":
      newState.resultsBlackoutAdd = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_RESPONSE_UPDATE":
      newState.resultsBlackoutPatch = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_RESPONSE_DELETE":
      newState.resultsBlackoutDelete = action.value || action.payload;
      newState.loading = false;
      break;
    case "BLACKOUT_PRODUCT_RESPONSE_ADD":
      newState.resultsBlackoutProductAdd = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_PRODUCTS_RESPONSE_GET":
      newState.resultsBlackoutProducts = action.value;
      newState.loading = false;
      break;
    case "BLACKOUT_PRODUCTS_RESPONSE_DELETE":
      newState.resultsBlackoutProductsDelete = action.value || action.payload;
      newState.loading = false;
      break;

    // OTHER ACTIONS
    case "BLACKOUT_RESPONSE_RESET":
      newState.resultsBlackout = {};
      break;
    case "RESET_BLACKOUT_RESPONSES":
      newState.resultsBlackoutAdd = {};
      newState.resultsBlackoutPatch = {};
      newState.resultsBlackoutDelete = {};
      newState.resultsBlackoutProductAdd = {};
      newState.resultsBlackoutProducts = {};
      newState.resultsBlackoutProductsDelete = {};
      newState.resultsBlackout = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
